import * as types from './sessionStatus.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_SESSIONSTATUS,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_SESSIONSTATUS,
		payload,
	}),
	get: payload => ({
		type: types.GET_SESSIONSTATUS,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_SESSIONSTATUS,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_SESSIONSTATUS,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
	setCanBeCreated: payload => ({
		type: types.SET_CAN_BE_CREATED,
		payload,
	}),
}
